<div data-test="PItQSWSB" class="form-group" [class.error]="invalid">
  <div data-test="VnREasvY" class="form-group__label">{{ label }}</div>

  <div data-test="YX8NVi5l" class="form-group__field form-group__field_append">
    <ng-content></ng-content>
  </div>

  <div data-test="jrnT4oOf" class="errors-wrapper" *ngIf="invalid">
    <ng-content select="ui-kit-error"></ng-content>
  </div>

  <div data-test="RCJeVuTk" class="form-group__hint text-right">
    <ng-content select="ui-kit-hint"></ng-content>
  </div>
</div>
